import { render, staticRenderFns } from "./TrustedLabelsPopup.vue?vue&type=template&id=ec3ffa02&"
import script from "./TrustedLabelsPopup.vue?vue&type=script&lang=ts&"
export * from "./TrustedLabelsPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports